export { a as attr, b as belongsTo, h as hasMany } from "./has-many-DT3JBYYG.js";
export { M as default } from "./model-rk3atPqV.js";
import '@ember-data/store/-private';
export { i as instantiateRecord, m as modelFor, t as teardownRecord } from "./hooks-CNY5g4Ab.js";
export { M as ModelSchemaProvider } from "./schema-provider-Bvogtzx9.js";